<template>
	<div class="sub-inverter row-center" style="justify-content: space-between">

		<div class="real-time-info">
			<div class="tit">
				{{currentLoop.label}}
			</div>

			<div class="info row-center" style="justify-content: space-between;align-content: space-between">

				<div class="item">
					<div class="k">状态</div>
					<div class="v">
						<span class="br">开机</span><span style="color: rgba(104, 216, 106, 1)">正常</span>
					</div>
				</div>

				<div class="item" >
					<div class="k">电能表总功率</div>
					<div class="v">
						<span class="v">100</span>
						<span class="unit">kW</span>
					</div>
				</div>

				<div class="item" style="width:27%">
					<div class="k">变流器效率</div>
					<div class="v">
						<span class="v">95</span>
						<span class="unit">%</span>
					</div>
				</div>
				<div class="item" >
					<div class="k">日充电量</div>
					<div class="v">
						<span class="v">160</span>
						<span class="unit">kWh</span>
					</div>
				</div>

				<div class="item" >
					<div class="k">日放电量</div>
					<div class="v">
						<span class="v">{{battery}}</span>
						<span class="unit">kWh</span>
					</div>
				</div>
				<div class="item"  style="width:27%">
					<div class="k">IGBT温度</div>
					<div class="v">
						<span class="v">45</span>
						<span class="unit">℃</span>
					</div>
				</div>
			</div>

		</div>

		<div class="right">

			<div class="enum row-center" style="justify-content: flex-start">
				<div :class="{active:isactive=='0'}" @click="isactive='0';$emit('isactive',0)">输出侧</div>
				<div :class="{active:isactive=='1'}" @click="isactive='1';$emit('isactive',0)">负载侧</div>
				<div :class="{active:isactive=='2'}" @click="isactive='2';$emit('isactive',0)">电网侧</div>
				<div :class="{active:isactive=='3'}" @click="isactive='3';$emit('isactive',0)">直流侧</div>
			</div>
			<div v-if="isactive=='0'"   class="info-card row-center out" style="justify-content: space-between">

				<div class="U column-center" style="width: 49%;">

					<div class="tit">
						三相线电压
					</div>

					<div class="column-center"
						style="justify-content: space-between; align-items: flex-start;width: 100%;">
						<div class="row row-center" >
							<div class="k">A(V):</div>
							<div class="v">418.2</div>
						</div>

						<div class="row row-center" >
							<div class="k">B(V):</div>
							<div class="v">418.6</div>
						</div>

						<div class="row row-center">
							<div class="k">C(V):</div>
							<div class="v">418.9</div>
						</div>

					</div>


				</div>
				<div class="I column-center" style="width: 49%;">

					<div class="tit">
						三相电流
					</div>

					<div class="column-center"
						style="justify-content: space-between; align-items: flex-start;width: 100%;">
						<div class="row row-center" >
							<div class="k">A(A):</div>
							<div class="v">239.22</div>
						</div>

						<div class="row row-center" >
							<div class="k">B(A):</div>
							<div class="v">239.23</div>
						</div>

						<div class="row row-center">
							<div class="k">C(A):</div>
							<div class="v">239.24</div>
						</div>

					</div>


				</div>

			</div>
			<div v-else-if="isactive=='3'"  class="info-card row-center" style="justify-content: space-between">
				<div class="F column-center" style="justify-content: flex-start;width:32%">

					<div class="tit">
						功率
					</div>

					<div class="row-center hz">
						100
						<span>KW</span>
					</div>

				</div>
				<div class="F column-center" style="justify-content: flex-start;width:32%">

					<div class="tit">
						电压
					</div>

					<div class="row-center hz">
						716.8
						<span>V</span>
					</div>

				</div>
				<div class="F column-center" style="justify-content: flex-start;width:32%">

					<div class="tit">
						电流
					</div>

					<div class="row-center hz">
						139.5
						<span>A</span>
					</div>

				</div>

			</div>
			<div v-else  class="info-card row-center" style="justify-content: space-between">

				<!-- <div class="P column-center" style="justify-content: flex-start">

					<div class="tit">
						功率
					</div>

					<div class="column-center"
						style="justify-content: space-between; align-items: flex-start;width: 100%;">
						<div class="row row-center" style="justify-content: space-between">
							<div class="k">功率因数:</div>
							<div class="v">0.123</div>
						</div>

						<div class="row row-center" style="justify-content: space-between">
							<div class="k">有功功率(kW):</div>
							<div class="v">0.123</div>
						</div>

						<div class="row row-center" style="justify-content: space-between">
							<div class="k">无功功率(kVar):</div>
							<div class="v">0.123</div>
						</div>

						<div class="row row-center" style="justify-content: space-between">
							<div class="k">视在功率(kVA):</div>
							<div class="v">0.123</div>
						</div>
					</div>


				</div> -->
				<div class="U column-center" style="justify-content: flex-start;width:32%">

					<div class="tit">
						三相线电压
					</div>

					<div class="column-center"
						style="justify-content: space-between; align-items: flex-start;width: 100%;">
						<div class="row row-center" style="justify-content: space-between">
							<div class="k">A(V):</div>
							<div class="v">418.5</div>
						</div>

						<div class="row row-center" style="justify-content: space-between">
							<div class="k">B(V):</div>
							<div class="v">418.7</div>
						</div>

						<div class="row row-center" style="justify-content: space-between">
							<div class="k">C(V):</div>
							<div class="v">418.1</div>
						</div>

					</div>


				</div>
				<div class="I column-center" style="justify-content: flex-start;width:32%">

					<div class="tit">
						三相电流
					</div>

					<div class="column-center"
						style="justify-content: space-between; align-items: flex-start;width: 100%;">
						<div class="row row-center" style="justify-content: space-between">
							<div class="k">A(A):</div>
							<div class="v">239.25</div>
						</div>

						<div class="row row-center" style="justify-content: space-between">
							<div class="k">B(A):</div>
							<div class="v">239.26</div>
						</div>

						<div class="row row-center" style="justify-content: space-between">
							<div class="k">C(A):</div>
							<div class="v">239.21</div>
						</div>

					</div>


				</div>
				<div class="F column-center" style="justify-content: flex-start;width:32%">

					<div class="tit">
						频率
					</div>

					<div class="row-center hz">
						50
						<span>HZ</span>
					</div>

				</div>

			</div>
		</div>


	</div>
</template>

<script>
	export default {
		name: "SubInverter",
		props:{
			currentLoop:Object
		},
		data(){
			return {
				isactive:0,
				battery:160
			}
		},
		mounted(){
			let time = new Date()
			if(time.getHours()<20){
				this.battery = 0
			}
		}
	}
</script>

<style scoped lang="less">

	.out {
		.k {
			margin-right: 74px;
		}
		.column-center{
			justify-content:flex-start
		}
	}

	.sub-inverter {
		width: 100%;
		height: 37vh;

		> div {
			height: 100%;
		}

		.real-time-info {
			background: #ffffff;
			width: 20.5vw;
			padding: 32rem 26rem;
			font-size: 21rem;
			font-weight: bold;
			color: #333333;

			.info {
				height: 74%;
				margin-top: 33px;

				.item {
					width: 33%;
					line-height: 1;

					.unit {
						color: rgba(13, 148, 255, 0.8) !important;
						font-size: 21rem;
					}

					&:first-child {
						span {
							font-size: 21rem;

							&:first-child {
								padding-right: 5px;
								padding-left: 0;
							}

							padding-left: 5px;
						}
					}

					span.br {
						border-right: 1px solid rgba(51, 51, 51, 1);
						color: rgba(51, 51, 51, 1);
					}

					.k {
						font-size: 20rem;
						font-weight: bold;
						color: #333333;
						margin-bottom: 30px;
					}

					.v {
						font-size: 28rem;
						font-weight: 400;
						color: #0D94FF;
					}
				}
			}

			.tit {
				padding-bottom: 8px;
				border-bottom: 1px solid rgba(0, 0, 0, 0.15);

				span {
					display: inline-block;
					height: 21px;
					line-height: 21px;

					&:first-child {
						border-right: 2px solid #333333;
						padding-right: 15px;
					}

					&:last-child {
						padding-left: 15px;
					}
				}
			}
		}

		.right {
			// padding: 24px 16px;
			padding:0px 16px 24px 16px;
			background: #ffffff;
			width: 45vw;
			
			.enum {
				font-size: 21rem;
				font-weight: bold;
				color: #333333;
				height: 42rem;
				line-height: 68rem;
				text-align: center;
				margin-bottom: 24px;
				> div {
					margin-right: 20px;
					cursor: pointer;
					// width: 80rem;
					text-align: center;
					border-top: 2px solid #ffffff;
					
					&.active {
						color: #0D94FF;
						border-top: 2px solid #0D94FF;
					}
				}

				
			}

		}

		.info-card {
			width: 100%;
			height: 83%;
			line-height: 0;


			> div {
				width: 180px;
				padding: 24px 16px;
				height: 100%;
			}

			.tit {
				font-size: 18px;
				line-height: 18px;
				font-weight: bold;
				color: #333333;
				margin-bottom: 50px;
			}

			.P {
				width: 24%;
				background: rgba(0, 0, 0, 0.04) url("../../assets/img/p.png") center no-repeat;
			}

			.U {
				background: rgba(0, 0, 0, 0.04) url("../../assets/img/u.png") center no-repeat;
			}

			.I {
				background: rgba(0, 0, 0, 0.04) url("../../assets/img/i.png") center no-repeat;
			}

			.F {
				position: relative;
				background: rgba(0, 0, 0, 0.04) url("../../assets/img/h.png") center no-repeat;

				.hz {
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
					font-size: 32px;
					font-weight: 500;
					color: #0D94FF;

					span {
						font-size: 24px;
					}
				}
			}

			.row {
				width: 100%;
				font-weight: 400;
				font-size: 16px;
				line-height: 16px;
				margin-top: 21px;

				&:first-child {
					margin-top: 0;
				}

				.k {
					color: #333333;
				}

				.v {
					color: #0D94FF;
				}
			}
		}
	}
</style>
